import * as actionTypes from './actionTypes';

export const setErrors = (payload) => ({
  type: actionTypes.SET_ERRORS,
  payload,
});

export const setExtExclusion = (payload) => ({
  type: actionTypes.SET_EXT_EXCLUSION,
  payload
});

export const getExtExclusions = (params) => ({
  type: actionTypes.GET_EXT_EXCLUSIONS,
  params
});

export const getExtExclusion = (id) => ({
  type: actionTypes.GET_EXT_EXCLUSION,
  id
});

export const createExtExclusion = (payload) => ({
  type: actionTypes.CREATE_EXT_EXCLUSION,
  payload
});

export const updateExtExclusion = (payload) => ({
  type: actionTypes.UPDATE_EXT_EXCLUSION,
  payload,
});

export const deleteExtExclusion = (Id) => ({
  type: actionTypes.DELETE_EXT_EXCLUSION,
  Id
});

export const setFilters = (payload) => ({
  type: actionTypes.SET_FILTERS,
  payload,
});


export const setOpenModal = (isOpen) => ({
  type: actionTypes.SET_OPEN_MODAL,
  payload: isOpen,
});

export const updateExtExclusionsOrder = (orderData) => ({
    type: actionTypes.UPDATE_EXT_EXCLUSIONS_ORDER,
    payload: { orderData }
});